const { Modal, ModalBody } = require("reactstrap");

const LoaderModal = ({ open, content }) => {
  return (
    <Modal isOpen={open}>
      <ModalBody className="p-5 fs-5 text-center fw-bold">{content}</ModalBody>
    </Modal>
  );
};

export default LoaderModal;
